// disables buttons and displays spinner
const disableForm = function () {
  $("#modal_deposit_spinner").show();
  $("#modal_deposit_batch_submit").attr("disabled", true);
  $("#modal_deposit_batch_cancel").attr("disabled", true);
};

// enables buttons and hides spinner
const enableForm = function () {
  $("#modal_deposit_spinner").hide();
  $("#modal_deposit_batch_submit").removeAttr("disabled");
  $("#modal_deposit_batch_cancel").removeAttr("disabled");
};

// updates the deposit batch dropdown with the new value
const updateSelector = function (data) {
  let select = $("select[data-batch-selector]");
  let option = select.children().first();
  $('<option value="' + data.id + '">' + data.code + "</option>").insertAfter(
    option,
  );
  select.val(data.id);
  updateBatchSelectionForSession(data.id);
};

// send the request to the server to create a new batch
const submitForm = function () {
  let code = $("#modal_deposit_batch_code").val();
  let notes = $("#modal_deposit_batch_notes").val();
  let campaign_id = $("#modal_deposit_batch_campaign_id").val();
  if (code.length == 0) {
    return;
  }

  disableForm();

  $.ajax({
    method: "POST",
    url: "/campaigns/" + campaign_id + "/deposit_batches.js",
    data: { deposit_batch: { code: code, notes: notes } },
    dataType: "json",
  })
    .done(function (data) {
      updateSelector(data);
      $("#new-batch-modal").modal("hide");
    })
    .fail(function (error) {
      alert("New batch could not be created - please try again.");
      enableForm();
    });
};

$(function () {
  // called when modal is first displayed
  $("#new-batch-modal").on("show.bs.modal", function (e) {
    $("#modal_deposit_batch_code").val("");
    $("#modal_deposit_batch_notes").val("");
    $("#modal_deposit_batch_submit").attr("disabled", true);
    $("#modal_deposit_batch_cancel").removeAttr("disabled");
    $("#modal_deposit_spinner").hide();
    // hack to put the focus into the "code" field - the timeout is apparently needed because
    // the input isn't onscreen yet when this is called (?)
    setTimeout(function () {
      $("#modal_deposit_batch_code").focus();
    }, 500);
  });

  // user typed a key in the "code" input
  $("#modal_deposit_batch_code").keydown(function (e) {
    if (e.which == 13) {
      e.preventDefault();
      submitForm();
      return;
    }
    let submitButton = $("#modal_deposit_batch_submit");
    if ($(this).val().length == 0) {
      submitButton.attr("disabled", true);
    } else {
      submitButton.removeAttr("disabled");
    }
  });

  // user typed a key in the "notes" input
  $("#modal_deposit_batch_notes").keydown(function (e) {
    if (e.which == 13) {
      e.preventDefault();
      submitForm();
      return;
    }
  });

  // user clicked the "create batch" button
  $("#modal_deposit_batch_submit").click(function () {
    submitForm();
  });
});
